import { defineComponent } from "vue";
import { RoomSb } from "~/extensions/utils/DefineTypes";
import { commonStore } from "~/store/CommonStore";
export default defineComponent({
    name: "NotFoundNyukyoDialog",
    props: {
        show: {
            type: Boolean,
            required: true
        },
        tenants: {
            type: Array,
            required: true
        }
    },
    emits: ["close"],
    setup(props, { emit }) {
        const close = () => {
            emit("close");
        };
        return {
            close,
            RoomSb,
            commonStore
        };
    }
});
